import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PageHeader from 'utility/PageHeader';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  DatePicker,
  Select,
  Space,
  Table,
  Popconfirm,
  Badge,
  Descriptions,
  Upload,
  message,
  Typography,
  Modal,
  InputNumber,
  Calendar,
  Radio,
  Checkbox,
  theme,
} from 'antd';
import {
  SearchOutlined,
  CloseOutlined,
  EditOutlined,
  UploadOutlined,
  DeleteOutlined,
  DownloadOutlined,
  PlusOutlined,
  ExclamationCircleFilled,
} from '@ant-design/icons';
import { gridSettingGenerator } from 'shared/common';
import { HttpHandler } from 'shared/httpHandler';
import LoadingComponent from 'shared/LoadingComponent';
import { useForm } from 'antd/es/form/Form';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import dayLocaleData from 'dayjs/plugin/localeData';
import StandardSection from 'utility/StandardSection';
import InfoTooltip from 'utility/InfoTooltip';
import { GutteredRow, CustomWidthCol } from 'utility/CustomLayout';
dayjs.extend(dayLocaleData);

const { Option } = Select;

const { TextArea } = Input;

const { RangePicker } = DatePicker;

const onChange = (value) => {
  console.log('changed', value);
};

const Example1 = () => {
  const [loading, setLoading] = useState(false);
  const [modalSampleVisible, setModalSampleVisible] = useState(false);
  const [form] = useForm();
  const translate = useIntl();
  const intlTranslate = (id) => {
    return translate.formatMessage({ id });
  };
  function loading_button_click() {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 5000);
  }
  async function confirm_button_click() {
    const confirmed = await window.antdConfirm('要確定欸？');
    if (confirmed) {
      console.log('確定了！');
    } else {
      console.log('取消了');
    }
  }
  async function alert_button_click() {
    const confirmed = await window.antdTimeOut('要確定欸？');
    if (confirmed) {
      console.log('確定了！');
    } else {
      console.log('取消了');
    }
  }

  const page_routes = [
    {
      title: <Link to="/home">首頁</Link>,
    },
    { title: '隱藏區域' },
    {
      title: <Link to="/example1">範例1</Link>,
    },
  ];
  //   -------------------------------------------
  //   -------------------------------------------
  const SettingCalendar = (props) => {
    const [selectedDates, setSelectedDates] = useState([]);
    const onSelect = (value) => {
      const dateString = value.format('YYYY-MM-DD');
      let newSelectedDates;

      if (selectedDates.includes(dateString)) {
        // Remove the date if already selected
        newSelectedDates = selectedDates.filter((date) => date !== dateString);
      } else {
        // Add the date if not selected
        newSelectedDates = [...selectedDates, dateString];
      }

      setSelectedDates(newSelectedDates);
    };
    const add_month = props.add_month;
    const { token } = theme.useToken();
    const onPanelChange = (value, mode) => {
      console.log(value.format('YYYY-MM-DD'), mode);
    };
    const disabledDate = (currentDate) => {
      // 获取当前月份
      const currentMonth = dayjs()
        .add(add_month - (dayjs().get('month') % 3), 'month')
        .month();
      // 禁用不是当前月份的日期
      return currentDate.month() !== currentMonth;
    };

    const dateCellRender = (value) => {
      const dateString = value.format('YYYY-MM-DD');
      const isSelected = selectedDates.includes(dateString);
      // console.log(value);

      return (
        <Row justify={'center'}>
          <Col span={14}>
            <div className={`date-cell ${isSelected ? 'selected' : ''}`}>
              {value.date() < 10 ? `0${value.date()}` : value.date()}
            </div>
          </Col>
        </Row>
      );
    };

    return (
      <div className="calendar-border">
        <Calendar
          fullscreen={false}
          fullCellRender={dateCellRender}
          onSelect={onSelect}
          onPanelChange={onPanelChange}
          disabledDate={disabledDate}
          defaultValue={dayjs().add(
            add_month - (dayjs().get('month') % 3),
            'month'
          )}
          headerRender={({ value, type, onChange, onTypeChange }) => {
            const start = 0;
            const end = 12;
            const monthOptions = [];
            let current = value.clone();
            const localeData = value.localeData();
            const months = [];
            for (let i = 0; i < 12; i++) {
              current = current.month(i);
              months.push(localeData.monthsShort(current));
            }
            for (let i = start; i < end; i++) {
              monthOptions.push(
                <Select.Option key={i} value={i}>
                  {months[i]}
                </Select.Option>
              );
            }
            const year = value.year();
            const month = value.month();
            return (
              <div className="py-2">
                <Row justify="center">
                  <Typography.Text strong>
                    {months[month]} {year}
                  </Typography.Text>
                </Row>
              </div>
            );
          }}
        />
      </div>
    );
  };
  SettingCalendar.propTypes = {
    add_month: PropTypes.number,
  };
  // ---------------------------------------------
  const QarterlyCalendar = () => {
    return (
      <Form.Item>
        <Row justify="space-between" align={'middle'}>
          <Col className="pd-4">
            <Typography.Text>
              Select the days which would provide special discount.
            </Typography.Text>
          </Col>
          <Col className="pd-4">
            <Space wrap>
              <Button>Clear</Button>
              <Button>Restore</Button>
              <Button type="primary">Default Holiday</Button>
            </Space>
          </Col>
        </Row>
        <Row>
          <Col>
            <Space className="calendar-display">
              <SettingCalendar add_month={0} />
              <SettingCalendar add_month={1} />
              <SettingCalendar add_month={2} />
            </Space>
          </Col>
        </Row>
      </Form.Item>
    );
  };
  // ---------------------------------------------

  const ImportData = () => {
    const [fileList, setFileList] = useState([]);

    const handleChange = (info) => {
      let newFileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      // Only to show two recent uploaded files, and old ones will be replaced by the new
      newFileList = newFileList.slice(-1);

      // 2. Read from response and show file link
      newFileList = newFileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });
      setFileList(newFileList);
    };

    const props = {
      action: 'https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188',
      onChange: handleChange,
      multiple: true,
    };

    const isButtonDisabled = fileList.length === 0;

    return (
      <Space direction="vertical">
        <Upload accept=".xlsx" {...props} fileList={fileList}>
          <Button icon={<UploadOutlined />}>Upload</Button>
        </Upload>
        <div>
          <Typography.Text>Download Sample :</Typography.Text>
          <Button
            icon={<DownloadOutlined />}
            type="link"
            href="URL to the sample file"
            target="_blank">
            Sample.xlsx
          </Button>
        </div>
        <Row>
          <Col>
            <Form.Item>
              <Button type="primary" disabled={isButtonDisabled}>
                Import
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Space>
    );
  };

  //   -------------------------------------------
  //   -------------------------------------------
  const SearchForm1 = () => {
    return (
      <Form layout="vertical" form={form}>
        <Row gutter={16}>
          <Col xs={24} sm={24} md={8} lg={8}>
            <Form.Item label="Application Type" name="selectType">
              <Select>
                <Option value="option1">Option1</Option>
                <Option value="option2">Option2</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            <Form.Item label="Application Status" name="selecStatus">
              <Select placeholder="Please choose">
                <Option value="option1">Processed</Option>
                <Option value="option2">Unprocessed</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            <Form.Item label="Date of Application" name="datePicker">
              <DatePicker.RangePicker className="w-full" format="YYYY-MM-DD" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          {/* 上面兩行Row可移除，不影響程式碼，目前先保留 */}
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item label="First Name" name="inputFirstName">
              <Input placeholder="ex: Amy、Paul..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item label="Last Name" name="inputLastName">
              <Input placeholder="ex: Williams、Smith..." />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item label="Phone Number" name="inputPhone">
              <Input placeholder="09xxxxxxxx" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={24} md={6} lg={6}>
            <Form.Item label="Result Status" name="selectResult">
              <Select>
                <Option value="option1">o_O</Option>
                <Option value="option2">QAQ</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {/* 搜尋和重置按鈕 */}
        <Row justify="end">
          <Col>
            <Form.Item>
              <Space>
                <Button onClick={() => form.resetFields()}>Clear</Button>
                <Button type="primary">Search</Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };
  //   -------------------------------------------
  const SearchForm2 = () => {
    return (
      <Form layout="vertical" form={form}>
        <Row gutter={16} align="bottom">
          <Col xs={24} sm={24} md={8} lg={8}>
            <Form.Item label="Order Number" name="inputFirstName">
              <Input />
            </Form.Item>
          </Col>
          {/* 搜尋和重置按鈕 */}
          <Col>
            <Form.Item>
              <Space>
                <Button onClick={() => form.resetFields()}>Clear</Button>
                <Button type="primary">Search</Button>
              </Space>
            </Form.Item>
          </Col>
        </Row>
        {/* 搜尋和重置按鈕 */}
      </Form>
    );
  };

  const SearchForm3 = () => {
    return (
      <Form layout="vertical" form={form}>
        <GutteredRow>
          <CustomWidthCol spanFraction={1}>
            <Form.Item label="spanFraction1">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={2}>
            <Form.Item label="spanFraction2-1">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={2}>
            <Form.Item label="spanFraction2-1">
              <Input />
            </Form.Item>
          </CustomWidthCol>
        </GutteredRow>
        <GutteredRow mode="bottom">
          <CustomWidthCol spanFraction={3}>
            <Form.Item label="spanFraction3-1">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={3}>
            <Form.Item label="spanFraction3-2">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol type="buttonGroup1">
            <Button onClick={() => form.resetFields()}>Clear</Button>
            <Button type="primary">Search</Button>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={4}>
            <Form.Item label="spanFraction4-1">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={4}>
            <Form.Item label="spanFraction4-2">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={4}>
            <Form.Item label="spanFraction4-3">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol spanFraction={4}>
            <Form.Item label="spanFraction4-4">
              <Input />
            </Form.Item>
          </CustomWidthCol>
          <CustomWidthCol type={'buttonGroup2'}>
            <Button onClick={() => form.resetFields()}>Clear</Button>
            <Button
              type="primary"
              onClick={() => {
                setModalSampleVisible(true);
              }}>
              Modal sample
            </Button>
          </CustomWidthCol>
        </GutteredRow>
        {/* 搜尋和重置按鈕 */}
      </Form>
    );
  };
  const ModalSample1 = () => {
    const onFinish = (values) => {
      console.log(values);
    };
    return (
      <Modal
        centered
        title="ModalSample1"
        className="common-modal"
        open={modalSampleVisible}
        onCancel={() => setModalSampleVisible(false)}
        footer={null}>
        <Form
          className="common-modal-form"
          layout="vertical"
          border=""
          onFinish={onFinish}>
          <GutteredRow mode="modal">
            <CustomWidthCol spanFraction={2}>
              <Form.Item label={'Disabled'}>
                <Input disabled={true} />
              </Form.Item>
            </CustomWidthCol>
            <CustomWidthCol spanFraction={2}>
              <Form.Item
                name="PackAmt"
                label={'Required'}
                rules={[
                  {
                    required: true,
                    message: 'Validation message.',
                  },
                ]}>
                <Input />
              </Form.Item>
            </CustomWidthCol>
            <CustomWidthCol spanFraction={2}>
              <Form.Item label="Date Select">
                <RangePicker className="w-full" />
              </Form.Item>
            </CustomWidthCol>
            <CustomWidthCol spanFraction={2}>
              <Form.Item label={'Option Select'}>
                <Radio.Group>
                  <Radio value={1}>{'Option1'}</Radio>
                  <Radio value={0}>{'Option2'}</Radio>
                </Radio.Group>
              </Form.Item>
            </CustomWidthCol>
            <CustomWidthCol spanFraction={1}>
              <div style={{ lineHeight: '22px' }}>{'Title'}</div>
              <div
                style={{
                  fontSize: '12px',
                  color: 'var(--character-secondary-45, rgba(0, 0, 0, 0.45))',
                  lineHeight: '20px',
                }}>
                {'Sub Title'}
              </div>
            </CustomWidthCol>
            <CustomWidthCol spanFraction={1}>
              <div className="flex">
                <Form.Item valuePropName="checked">
                  <Checkbox>{'Checkbox1'}</Checkbox>
                </Form.Item>
                <Form.Item>
                  <Input />
                </Form.Item>
              </div>
            </CustomWidthCol>
            <CustomWidthCol spanFraction={1}>
              <Form.Item valuePropName="checked">
                <Checkbox>{'Checkbox2'}</Checkbox>
              </Form.Item>
            </CustomWidthCol>
          </GutteredRow>
          <Row className="common-modal-footer">
            <CustomWidthCol type="buttonGroup3">
              <Button>{'Cancel'}</Button>
              <Button type="primary" htmlType="submit">
                {'Confirm'}
              </Button>
            </CustomWidthCol>
          </Row>
        </Form>
      </Modal>
    );
  };
  //   -------------------------------------------
  const SearchTable1 = () => {
    const items = [
      {
        key: '1',
        label: 'Product',
        children: 'Cloud Database',
      },
      {
        key: '2',
        label: 'Billing',
        children: 'Prepaid',
      },
      {
        key: '3',
        label: 'Time',
        children: '18:00:00',
      },
      {
        key: '4',
        label: 'Amount',
        children: '$80.00',
      },
      {
        key: '5',
        label: 'Discount',
        children: '$20.00',
      },
      {
        key: '6',
        label: 'Official',
        children: '$60.00',
      },
    ];
    const data = [
      {
        key: '1',
        firstname: 'Mark Elliot',
        lastname: 'Zuckerberg',
        date: '2023/11/12',
        phone: '1-626-780-7552',
        remark:
          'Lorem ipsum dolor sit amet, has in movet dignissim efficiantur. Hello!World~',
        timerange: '2023/08/04 00:00 ~ 2023/08/05 23:40',
        result: 'Not Applied',
        blacklist: 'No',
        description: 'Zuckerberg is a lizard Man (o^^o)',
      },
      {
        key: '2',
        firstname: 'Elon Reeve',
        lastname: 'Musk',
        date: '2023/11/11',
        phone: '1-841-000-6781',
        remark: '',
        result: 'Applied',
        blacklist: 'No',
        description: '',
      },
      {
        key: '3',
        firstname: 'Elizabeth',
        lastname: 'Alexandra Mary',
        date: '2023/11/10',
        phone: '1-841-777-0622',
        remark: '',
        result: 'Meow',
        blacklist: 'No',
        description: '',
      },
    ];
    const totalItems = data.length;

    const columns = [
      {
        title: '#',
        dataIndex: 'key',
        width: 44,
        ellipsis: true,
      },
      {
        title: 'Full Name',
        children: [
          {
            title: 'First Name',
            width: 104,
            dataIndex: 'firstname',
            key: 'firstname',
            ellipsis: true,
          },
          {
            title: 'Last Name',
            width: 104,
            dataIndex: 'lastname',
            key: 'lastname',
            ellipsis: true,
          },
        ],
      },
      {
        title: 'Date of Application',
        dataIndex: 'date',
        key: 'date',
        sorter: true,
        render: (_, record) => (
          <div>
            <div className="mb-1">{record.date}</div>
            <div>
              <Button type="primary" size="small" ghost icon={<EditOutlined />}>
                Edit
              </Button>
            </div>
          </div>
        ),
      },
      {
        title: 'Phone Number',
        dataIndex: 'phone',
        key: 'phone',
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
        key: 'remark',
        ellipsis: true,
      },
      {
        title: 'Est. Start / End Time',
        width: 168,
        dataIndex: 'timerange',
        key: 'timerange',
      },
      {
        title: 'Verification Result',
        dataIndex: 'result',
        key: 'result',
        render: (_, record) => {
          const { result } = record;
          if (result === 'Applied') {
            return <Badge status="success" text="Applied" />;
          } else if (result === 'Not Applied') {
            return <Badge status="error" text="Not Applied" />;
          } else {
            // 处理其他可能的状态值，或者返回默认的 Badge 组件
            return <Badge status="default" text={result} />;
          }
        },
      },
      {
        title: 'Blacklist',
        dataIndex: 'blacklist',
        key: 'blacklist',
        width: 88,
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 128,
        render: (_, record) => (
          <Space size="middle">
            <Popconfirm title="Sure to delete?">
              <a>Delete</a>
            </Popconfirm>
            <a>Verify</a>
          </Space>
        ),
      },
    ];

    return (
      <div>
        <Row justify="space-between" align={'middle'} className="mb-2">
          <Col>
            <div>Total {totalItems} items</div>
          </Col>
          <Col>
            <Button>Export</Button>
          </Col>
        </Row>
        <Descriptions size={'small'} items={items} />
        <Table
          columns={columns}
          expandable={{
            expandedRowRender: (record) => (
              <p className="m-0">{record.description}</p>
            ),
            rowExpandable: (record) => record.description !== '',
          }}
          dataSource={data}
          bordered
          scroll={{
            x: 1120,
          }}
          pagination={{
            pageSize: 10, // 每页显示的记录数
            total: totalItems, // 数据总数
            showSizeChanger: true, // 显示每页条数切换器
          }}
        />
      </div>
    );
  };
  //   -------------------------------------------
  const SearchBar = () => {
    return (
      <Form name="search" layout="vertical" className="form--flex1" form={form}>
        <Row>
          <Col {...gridSettingGenerator(1)}>
            <Form.Item
              label="車牌號碼"
              name="CarNo"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Input />
            </Form.Item>
          </Col>
          <Col {...gridSettingGenerator(2)}>
            <Form.Item
              label="動作類型"
              name="SpecCode"
              rules={[
                {
                  required: true,
                },
              ]}>
              <Select
                options={[
                  { label: '清潔', value: '1' },
                  { label: '保修', value: '2' },
                ]}
                placeholder="請選擇類型"
              />
            </Form.Item>
          </Col>
          <Col {...gridSettingGenerator(3)}>
            <Form.Item
              label="取還車時間"
              name="time"
              rules={[
                {
                  required: true,
                },
              ]}>
              <DatePicker.RangePicker
                className="w-full"
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
              />
            </Form.Item>
          </Col>
          <Col {...gridSettingGenerator(0)}>
            <Form.Item className="button-group">
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
                className="button button--search">
                確定送出
              </Button>
              <Button
                type="primary"
                icon={<CloseOutlined />}
                className="button button--delete"
                onClick={() => {
                  form.resetFields();
                }}>
                清除
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  };
  //   -------------------------------------------
  const ButtonShow = () => {
    return (
      <Space wrap>
        <Button onClick={loading_button_click}>Loading 5 seconds</Button>
        <Button onClick={confirm_button_click}>open confrim modal</Button>
        <Button onClick={alert_button_click}>open alert modal</Button>
      </Space>
    );
  };
  //   -------------------------------------------
  const TableShow = () => {
    const origin_data = [
      {
        the_name: 'Jimmy',
        nick_name: '吉米',
        AKA: '投資小王子,通靈王,順毛怪,空氣閱讀大師,寫輪眼的旗木吉吉米',
      },
      {
        the_name: 'Charles',
        nick_name: '升升',
        AKA: '文件怪人,曾帥哥,曾帥,AKS大師',
      },
      { the_name: 'How', nick_name: '浩浩', AKA: '前端怪人' },
      { the_name: 'Albert', nick_name: '彥博', AKA: '職場渣男,辨識怪人' },
      { the_name: 'Luke', nick_name: '路克', AKA: '天行者,死神' },
    ];
    const columns = [
      {
        title: 'the_name',
        dataIndex: 'the_name',
      },
      {
        title: 'nick_name',
        dataIndex: 'nick_name',
      },
      {
        title: 'AKA',
        dataIndex: 'AKA',
      },
    ];
    return <Table dataSource={origin_data} columns={columns}></Table>;
  };
  //   -------------------------------------------
  //   -------------------------------------------
  //   -------------------------------------------
  //   -------------------------------------------

  //   -------------------------------------------
  const ImageUploader = () => {
    const [fileList, setFileList] = useState([]);
    const onChange = ({ fileList: newFileList }) => {
      // 只保留最后上传的图片
      const latestFile = newFileList.slice(-1);
      setFileList(latestFile);
    };
    const onPreview = async (file) => {
      let src = file.url;
      if (!src) {
        src = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.originFileObj);
          reader.onload = () => resolve(reader.result);
        });
      }
      const image = new Image();
      image.src = src;
      const imgWindow = window.open(src);
      imgWindow?.document.write(image.outerHTML);
    };
    return (
      <Upload
        accept="image/*"
        beforeUpload={() => false}
        listType="picture-card"
        fileList={fileList}
        onChange={onChange}
        onPreview={onPreview}>
        {fileList.length < 1 && '+ Upload'}
      </Upload>
    );
  };
  //   -------------------------------------------
  const { confirm } = Modal;
  const showConfirm = () => {
    confirm({
      centered: true,
      title: 'Do you Want to delete these items?',
      icon: <ExclamationCircleFilled />,
      content: '',
      onOk() {
        console.log('OK');
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  };
  const TableModal = () => {
    const [tableModalOpen, setTableModalOpen] = useState(false);
    const columns = [
      {
        title: 'Modified Date',
        dataIndex: 'date',
        // render: (text) => (
        //   <>
        //     {text.split(' ')[0]}
        //     <br />
        //     {text.split(' ')[1]}
        //   </>
        // ),
      },
      {
        title: 'Modified by',
        dataIndex: 'name',
      },
      {
        title: 'Application Type',
        dataIndex: 'type',
      },
      {
        title: 'Application Status',
        dataIndex: 'status',
      },
      {
        title: 'Reject Reason',
        dataIndex: 'reason',
      },
      {
        title: 'A',
        dataIndex: 'A',
      },
      {
        title: 'B',
        dataIndex: 'B',
      },
      {
        title: 'C',
        dataIndex: 'C',
      },
    ];
    const data = [
      {
        key: '1',
        date: '2023-10-30 08:30AM',
        name: 'John Doe ',
        type: 'Change Identity',
        status: 'Approved',
        reason: '',
        A: '12345678945123456456',
        C: '456546456546564456465',
        // B: '12345678945123456456',
      },
      {
        key: '2',
        date: '2023-10-2810:15AM',
        name: 'Jane Smith',
        type: 'Apply for Membership',
        status: 'Rejected',
        reason: 'Incomplete Information',
      },
      {
        key: '3',
        date: '2023-10-25 09:45AM',
        name: 'Bob Johnson',
        type: 'Apply for Membership',
        status: 'Pending  ',
        reason: '',
      },
      {
        key: '4',
        date: '2023-10-30 08:30AM',
        name: 'John Doe ',
        type: 'Change Identity',
        status: 'Approved',
        reason: '',
      },
      {
        key: '5',
        date: '2023-10-28 10:15AM',
        name: 'Jane Smith',
        type: 'Apply for Membership',
        status: 'Rejected',
        reason: 'Incomplete Information',
      },
      {
        key: '6',
        date: '2023-10-25 09:45AM',
        name: 'Bob Johnson',
        type: 'Apply for Membership',
        status: 'Pending  ',
        reason: '',
      },
    ];
    return (
      <Space>
        <Button onClick={() => setTableModalOpen(true)} type="primary">
          Table Modal
        </Button>
        <Modal
          className="common-modal"
          // width={800}
          centered
          title="Modified History"
          open={tableModalOpen}
          onOk={() => setTableModalOpen(false)}
          onCancel={() => setTableModalOpen(false)}>
          <div className="common-modal-content">
            <Table
              columns={columns}
              dataSource={data}
              size="small"
              pagination={{ pageSize: 5 }}
              scroll={{
                x: 800,
                y: 400,
              }}
            />
          </div>
        </Modal>
      </Space>
    );
  };
  const FormModal = () => {
    const [formModalOpen, setFormModalOpen] = useState(false);
    return (
      <Space>
        <Button onClick={() => setFormModalOpen(true)} type="primary">
          Form Modal
        </Button>
        <Modal
          centered
          title="Add Information"
          open={formModalOpen}
          onOk={() => setFormModalOpen(false)}
          onCancel={() => setFormModalOpen(false)}>
          <Form
            className="form-in-modal"
            layout="vertical"
            form={form}
            initialValues={{
              carbrand: 'option1',
              cartype: 'option1',
            }}>
            <Row gutter={16}>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Car Model Code" name="carcode">
                  <Input placeholder="NSP151-4067819" />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Vehicle Brand" name="carbrand">
                  <Select>
                    <Option value="option1">Toyota</Option>
                    <Option value="option2">LEXUS</Option>
                    <Option value="option3">HINO</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Car Model" name="carmodel">
                  <Input placeholder="White" />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Car Type" name="cartype">
                  <Select>
                    <Option value="option1">YARIS</Option>
                    <Option value="option2">PRIUSc</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Weekday Rate" name="weekdayRate">
                  <InputNumber
                    className="w-full"
                    formatter={(value) =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    onChange={onChange}
                  />{' '}
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Holiday Rate" name="holidayRate">
                  <InputNumber
                    className="w-full"
                    formatter={(value) =>
                      `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    }
                    parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                    onChange={onChange}
                  />{' '}
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item label="Description(in APP)" name="desc">
                  <TextArea
                    placeholder="Lorem ipsum dolor sit amet, consectetur adipisicing elit."
                    autoSize={{
                      minRows: 2,
                      maxRows: 2,
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Form.Item label="Vehicle Images" name="carphoto">
                  <ImageUploader className="w-full" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Space>
    );
  };
  //   -------------------------------------------
  const ImportModal = () => {
    const [importModalOpen, setImportModalOpen] = useState(false);

    const [fileList, setFileList] = useState();

    const handleChange = (info) => {
      let newFileList = [...info.fileList];

      // 1. Limit the number of uploaded files
      // Only to show two recent uploaded files, and old ones will be replaced by the new
      newFileList = newFileList.slice(-1);

      // 2. Read from response and show file link
      newFileList = newFileList.map((file) => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url;
        }
        return file;
      });
      setFileList(newFileList);
    };

    const props = {
      action: 'https://run.mocky.io/v3/435e224c-44fb-4773-9faf-380c5e6a2188',
      onChange: handleChange,
      multiple: true,
    };

    return (
      <Space direction="vertical">
        <Button onClick={() => setImportModalOpen(true)}>Import Modal</Button>
        <Modal
          centered
          title="import"
          open={importModalOpen}
          onOk={() => setImportModalOpen(false)}
          onCancel={() => setImportModalOpen(false)}>
          <Form className="form-in-modal" layout="vertical" form={form}>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item label="Import Type">
                  <Select>
                    <Option value="option1">Batch Import</Option>
                    <Option value="option2">Single Import</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form.Item label="Select File">
                  <Upload accept=".xlsx" {...props} fileList={fileList}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                  <div>
                    <span>Download Sample :</span>
                    <Button
                      icon={<DownloadOutlined />}
                      type="link"
                      href="URL to the sample file"
                      target="_blank">
                      Sample.xlsx
                    </Button>
                  </div>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Space>
    );
  };
  //   -------------------------------------------
  const MoMo = () => {
    return (
      <Space wrap>
        <TableModal />
        <Button onClick={showConfirm}>Confirm</Button>
        <FormModal />
        <ImportModal />
      </Space>
    );
  };
  //   -------------------------------------------
  //   -------------------------------------------
  //   -------------------------------------------

  const SECTIONS = [
    // { title: 'Search', children: <SearchBar /> },
    // { title: 'Button Show', children: <ButtonShow /> },
    { title: 'Weekday / Holiday Setting', children: <QarterlyCalendar /> },
    { title: 'Popup Modal Box', children: <MoMo /> },
    { title: 'Import Data', children: <ImportData />, collapse: true },
    { title: 'Search Form 1', children: <SearchForm1 />, collapse: true },
    { title: 'Search Form 2', children: <SearchForm2 />, collapse: true },
    { title: 'Search Form 3', children: <SearchForm3 />, collapse: true },
    { title: 'Search Table 1', children: <SearchTable1 />, collapse: true },
    {
      title: 'Search',
      children: <SearchBar />,
      hasInfo: true,
      info: '最簡單的SearchBar示例',
      modalContent: '94這麼簡單',
    },
    { title: 'Button Show', children: <ButtonShow /> },
    { title: 'Table', children: <TableShow /> },
  ];

  return (
    <div>
      <PageHeader functionName={'menu-0-1'}>
        <Button type="primary" icon={<PlusOutlined />}>
          Add
        </Button>
      </PageHeader>
      <LoadingComponent loading={loading}></LoadingComponent>
      <div className="main-container">
        {SECTIONS.map((section, index) => (
          <StandardSection key={index} {...section} />
        ))}
      </div>
      <ModalSample1 />
    </div>
  );
};

export default Example1;
